export default "__VITE_ASSET__08a96d0e__"